import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			'& > *': {
				margin: 0,
				fontFamily: 'Poppins',
				fontSize: '16px',
			},
		},
		input: {
			display: 'none',
		},

		boxContainer: {
			height:'inherit',
			display: 'flex',
			flexDirection: 'row',
			flexWrap: 'nowrap',
			width: '90%',
			margin: '0 auto',
			fontFamily: 'Poppins',
			fontSize: '16px',
			[theme.breakpoints.down('xs')]: {
				flexDirection: 'column',
			},
		},
		boxA: {
			// height:'auto',
			background: '#D0E6A5',
			color: '#78393D',
			width: '33.333%',
			height: 'auto',
			display: 'flex',
			alignItems: 'center',
			flexDirection: 'column',
			justifyContent: 'center',
			textAlign: 'left',
			borderRadius: 20,
			borderTopRightRadius: 0,
			borderBottomRightRadius: 0,
			padding: '.5rem 2rem',
			listStyleType: 'none',
			fontFamily: 'Poppins',
			fontSize: '16px',
			[theme.breakpoints.down('xs')]: {
				borderTopRightRadius: 20,
				borderBottomRightRadius: 20,
				width: '100%',
			},
		},
		boxB: {
			background: '#E6E6E6',
			color: '#78393D',
			width: '33.333%',
			borderRadius: 20,
			height: 'auto',
			borderTopRightRadius: 0,
			borderBottomRightRadius: 0,
			borderTopLeftRadius: 0,
			borderBottomLeftRadius: 0,
			padding: '.5rem 2rem',
			fontFamily: 'Poppins',
			fontSize: '16px',
			[theme.breakpoints.down('xs')]: {
				display: 'none',
			},
		},
		boxC: {
			background: '#A9BAF2',
			color: '#78393D',
			width: '33.333%',
			height: 'auto',
			display: 'flex',
			alignItems: 'center',
			flexDirection: 'column',
			justifyContent: 'center',
			listStyleType: 'none',
			borderRadius: 20,
			borderTopLeftRadius: 0,
			borderBottomLeftRadius: 0,
			padding: '.5rem 2rem',
			fontFamily: 'Poppins',
			fontSize: '16px',
			[theme.breakpoints.down('xs')]: {
				borderTopLeftRadius: 20,
				borderBottomLeftRadius: 20,
				width: '100%',
				height:'auto'
			},
		},
		redBoxContainer: {
			background: '#FC887B',
			width: '90%',
			display: 'flex',
			justifyContent: 'center',
			flexDirection: 'column',
			alignItems: 'center',
			flexWrap: 'nowrap',
			padding: '.5rem .8rem',
			borderRadius: 20,
			color: '#78393D',
			margin: '0 auto',
			fontFamily: 'Poppins',
			fontSize: '16px',
		},
		redBoxDiv: {
			display: 'flex',
			width: '100%',
			justifyContent: 'space-between',
			alignItems: 'center',
			flexWrap: 'nowrap',
			padding: '.5rem .8rem',
			borderRadius: 20,
			color: '#78393D',
			fontFamily: 'Poppins',
			fontSize: '16px',
		},
		supplies: {
			color: '#78393D',
			// width: '50%',
			height: '233.87px',
			display: 'flex',
			alignItems: 'center',
			flexDirection: 'column',
			justifyContent: 'center',
			padding: '.5rem 1rem',
			listStyleType: 'none',
			fontFamily: 'Poppins',
			fontSize: '16px',
		},
		bigBelowBox: {
			[theme.breakpoints.down('xs')]: {
				margin: '.5rem',
			},
		},
		error: {
			fontSize: '16px',
			color: 'red',
			padding:'1rem'
		},
		Nocard: {
			maxWidth: 345,
		},
		button: {
			background: 'grey',
			border: 'none',
			color: 'white',
			borderRadius: '2px',
			margin: '1rem 0',
			fontSize: '12px',
		},
		loading: {
			display: 'flex',
			justifyContent: 'center',
			flexDirection: 'column',
			alignItems: 'center',
			marginTop: '5rem',
		},
		topImage: {
			display:'flex',
			margin:'0 auto',
			width: '70%',
			height: '473px',
			borderRadius: '10px',
			objectFit: 'contain',
			[theme.breakpoints.down('xs')]: {
				width: '100%',
			},
		},
		goal:{
			display:'flex',
			justifyContent:'center',
			alignItems:'center',
			padding: '1.2rem',
			margin:'0 2rem',
			fontSize: '14px',
			lineHeight: 1.4,
			color: '#78393D'
		}
	}),
);
